import { createAsyncThunk } from "@reduxjs/toolkit";
import apiEndpoints from "../../const/apiEndpoints";
import history from "../../const/history";
import api from "../../services";

export const getLesson = createAsyncThunk(
    'lesson/Getlesson',
    async (userId: string): Promise<any> => {
        const response = await api.get(`${apiEndpoints.getLesson}/${userId}`,)
        return response?.data
    }
)

export const updateLessonPlane = createAsyncThunk(
    'lesson/UpdateLesson',
    async (requestPayload: any): Promise<any> => {
        const response = await api.post(`${apiEndpoints.lessonUpdate}`, requestPayload)
        if (response?.data) {
            history.goBack()
        }
        return response?.data
    }
)